import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { TextField, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { createTheme } from "@mui/material/styles";
import { useTheme } from "@mui/material";
import {useCart} from "../context/CartContext";
import {thousandSeparator} from "../utils/Utils";

const ProductCard = ({ product }) => {
    const theme = useTheme();
    const {openCart, updateQuantity} = useCart()

    const buttonTheme = createTheme({
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        color: 'white',
                        backgroundColor: theme.palette.primary[500],
                        '&:hover': {
                            backgroundColor: theme.palette.secondary.main,
                        },
                        borderRadius: 30,
                        textTransform: 'capitalize',
                        width: 'fit-content',
                        fontFamily: 'Archivo',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: '18px',
                        padding: '15px 16px 15px 12px'
                    }
                }
            }
        },
    });

    const [quantity, setQuantity] = React.useState(1);

    const handleQuantityChange = (amount) => {
        setQuantity((prev) => Math.max(1, prev + amount)); // Ensure quantity is at least 1
    };

    return (
        <Card style={{ background: '#fff', borderRadius: '16px' }}>
            <CardMedia
                component="img"
                alt={product?.name}
                height="320"
                image={product?.image}
            />
            <CardContent style={{ paddingTop: '32px', paddingLeft: '32px' }}>
                <Typography gutterBottom variant="headline6" component="div">
                    {product?.name}
                </Typography>
                <Typography variant="body1" style={{ color: '#536B74', marginBottom: '16px' }}>
                    {product?.description}
                </Typography>
                <Typography variant="body1" color='primary.main'>
                    {thousandSeparator(product?.price)} Ft
                </Typography>
                <Typography variant="body2" color='primary.200'>
                    Nettó ár: {thousandSeparator(Math.round(product?.price / (1 + product?.vat_percent / 100)))} Ft
                </Typography>
            </CardContent>
            <CardActions style={{ paddingBottom: '32px', paddingLeft: '32px', display: 'flex', alignItems: 'center' }}>
                <IconButton onClick={() => handleQuantityChange(-1)} color='primary.main'>
                    <RemoveIcon />
                </IconButton>
                <TextField
                    value={quantity}
                    onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
                    style={{ width: '60px', textAlign: 'center' }}
                    inputProps={{ style: { textAlign: 'center' } }}
                    variant='standard'
                />
                <IconButton onClick={() => handleQuantityChange(1)} color='primary.main'>
                    <AddIcon />
                </IconButton>
                <Button
                    onClick={() => {
                        updateQuantity(product, quantity)
                        setQuantity(1)
                        openCart()
                    }}
                    theme={buttonTheme}
                    style={{ marginLeft: '16px' }}
                >
                    Kosárba rakom
                </Button>
            </CardActions>
        </Card>
    );
};

export default ProductCard;
